import React from 'react'
import { useField, useForm } from 'components/Form/hooks'
import { useIntl } from 'react-intl'
import { UpdateFormContext } from 'utils/types/updateForm'
import theme from 'utils/theme'
import { MAX_TITLE_COUNTER_CHARACTERS } from 'utils/constants/updates'
import { Content, DatePicker, Input, Row, TextArea } from '../commons'
import MediaUploader from '../MediaUploader/MediaUploader'
import MultipleFundSelector from '../commons/InvestorFundSelector/MultipleInvestorFundSelector'

const NoteForm: React.FC = () => {
  const intl = useIntl()
  const { disabled, showInvestorAndFundSelector } = useForm<UpdateFormContext>()
  const [titleField] = useField('title')

  return (
    <Content>
      <Row>
        <Input
          id="title"
          label={intl.formatMessage({
            id: 'updates.note.title.label',
          })}
          name="title"
          placeholder={intl.formatMessage({
            id: 'updates.note.title.placeholder',
          })}
          title={intl.formatMessage({
            id: 'updates.note.title.label',
          })}
          withCounter
          customMaxCounterCharacters={MAX_TITLE_COUNTER_CHARACTERS}
          counterSubtractNumber={titleField.value.length}
          simulateIconSpace
          counterStyle={{
            right: '2rem',
            top: '1.2rem',
            color: theme.colors.darkGray,
            opacity: 0.5,
          }}
          extraPaddingRight={1.5}
        />
        <DatePicker
          id="date"
          name="date"
          label={intl.formatMessage({ id: 'updates.common.publishDate' })}
        />
      </Row>

      {!!showInvestorAndFundSelector && <MultipleFundSelector />}

      <TextArea
        id="body"
        label={intl.formatMessage({
          id: 'updates.note.body.label',
        })}
        isOptional
        name="body"
        title={intl.formatMessage({
          id: 'updates.note.body.label',
        })}
        placeholder={intl.formatMessage({
          id: 'updates.note.body.placeholder',
        })}
        rows={5}
      />
      <MediaUploader allowMultipleContents name="files" disabled={disabled} />
    </Content>
  )
}

export default NoteForm
